import { createFileRoute, redirect } from '@tanstack/react-router';

// Ruta index "/" : el guard de _authenticated ya manda a /login si no hay sesion.
// Si hay sesion, redirige a la primera seccion (Chats).
export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: () => {
    throw redirect({ to: '/chats' });
  },
});
